// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"890123b6","259":"661e6dd0","771":"1b6e43cd","924":"b5747365"}[chunkId] + ".chunk.css";
};